export default __webpack_public_path__ + "static/media/close.54e3dd7b.svg";